import { Form, Typography } from "antd";
import AppContent from "common/AppContent";
import AppPageHeader from "common/PageHeader";
import ExtraContent from "components/Configuration/CommonComponents/ExtraContent";
import { NO_PERMISSION_REQUIRED } from "routes/permissions";
import { hasPermission } from "utils/functions";
import SalesContractForm from "../SalesContractForm";
// Antd Constants
const { Title } = Typography;
export default function SalesContractExpenseCreate() {
  const [form] = Form.useForm();

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                hideFilterButton
                addButtonText={
                  hasPermission([NO_PERMISSION_REQUIRED])
                    ? "Add New"
                    : "No Permission"
                }
                handleAddItemOpen={() => form.submit()}
                showBackButton
              />
            }
            title={<Title level={5}>Sales Contract Expense Create</Title>}
          />
        }
        content={
          <>
            <SalesContractForm form={form} mode="create" />
          </>
        }
      />
    </>
  );
}
